// TODO the ? is really ugly, we should instantiate this whole component only if we know we have all the elements in the DOM
const getActionBarElement = () => document.getElementById('action-bar');

const ActionBar = {
    show: (count) => {
        const actionBarElement = getActionBarElement();

        if (!actionBarElement) {
            return;
        }

        actionBarElement.classList.add('visible');
        actionBarElement.querySelector('span.count').innerHTML = count;
    },
    close: () => {
        const actionBarElement = getActionBarElement();

        if (!actionBarElement) {
            return;
        }

        actionBarElement.classList.remove('visible');
    },
};

export const toggleActionBar = checkboxes => {
    const checkedCheckboxesCount = checkboxes.reduce((count, checkbox) => checkbox.checked ? count + 1 : count, 0);

    if (checkedCheckboxesCount > 0) {
        ActionBar.show(checkedCheckboxesCount);
    } else {
        ActionBar.close();
    }
};
